export const OPEN_TAB_WITH_CODE_TO_SEARCH = 'OPEN_TAB_WITH_CODE_TO_SEARCH'
export const CHANGE_SORTING = 'CHANGE_SORTING'
export const GET_LIST_OF_STUDENTS = 'GET_LIST_OF_STUDENTS'
export const GET_LIST_OF_INTERACTIONS = 'GET_LIST_OF_INTERACTIONS'
export const SEARCH_LIST_OF_STUDENTS = 'SEARCH_LIST_OF_STUDENTS'
export const GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT = 'GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REFRESH_LOGIN = 'REFRESH_LOGIN'
export const APPLY_SESSION_EXPIRED_ACTIONS = 'APPLY_SESSION_EXPIRED_ACTIONS'
export const LOGIN_SSO_ACTION = 'LOGIN_SSO_ACTION'
export const LOGIN_SAML_ACTION = 'LOGIN_SAML_ACTION'
export const REFRESH_SSO_TOKEN = 'REFRESH_SSO_TOKEN'
export const GET_CONFIG_DETAILS = 'GET_CONFIG_DETAILS'
export const GET_LANGUAGE_DETAILS = 'GET_LANGUAGE_DETAILS'
export const GET_LANGUAGE_DETAILS_PER_LOCALE = 'GET_LANGUAGE_DETAILS_PER_LOCALE'
export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN'

// Student specific
export const GET_STUDENT = 'GET_STUDENT'
export const GET_STUDENT_PROFILE = 'GET_STUDENT_PROFILE'
export const GET_STUDENT_INTERACTIONS = 'GET_STUDENT_INTERACTIONS'
export const GET_STUDENT_MODULES = 'GET_STUDENT_MODULES'
export const REPLACE_STUDENT_INTERACTIONS = 'REPLACE_STUDENT_INTERACTIONS'
export const GET_STUDENT_AVERAGE_ATTENDANCE = 'GET_STUDENT_AVERAGE_ATTENDANCE'
export const GET_STUDENT_COURSE_AVERAGE_ATTENDANCE = 'GET_STUDENT_COURSE_AVERAGE_ATTENDANCE'
export const STUDENTS_LIST_CHANGE_FILTER = 'STUDENTS_LIST_CHANGE_FILTER'
export const STUDENTS_LIST_CHANGE_LIST_FILTER = 'STUDENTS_LIST_CHANGE_LIST_FILTER'
export const GET_COURSES_FOR_STUDENTS = 'GET_COURSES_FOR_STUDENTS'
export const CLEAR_STUDENTS_LIST_FILTERS_ACTION = 'CLEAR_STUDENTS_LIST_FILTERS_ACTION'
export const GET_CUSTOM_FILTERS_FOR_STUDENTS = 'GET_CUSTOM_FILTERS_FOR_STUDENTS'
export const GET_STUDY_MODES_STUDENTS = 'GET_STUDY_MODES_STUDENTS'
export const GET_ENROLMENT_STATUS_STUDENTS = 'GET_ENROLMENT_STATUS_STUDENTS'
export const GET_COURSE_YEARS_STUDENTS = 'GET_COURSE_YEARS_STUDENTS'
export const GET_COURSE_LEVELS_STUDENTS = 'GET_COURSE_LEVELS_STUDENTS'
export const POST_STUDENT_HELP_POPUP = 'POST_STUDENT_HELP_POPUP'
export const POST_STUDENT_HELP_POPUP_ARTICLE = 'POST_STUDENT_HELP_POPUP_ARTICLE'

export const ORGANISE_SAVED_FILTERS_FOR_STAFF = 'ORGANISE_SAVED_FILTERS_FOR_STAFF'
export const CLEAR_SAVED_FILTERS_FOR_STAFF = 'CLEAR_SAVED_FILTERS_FOR_STAFF'
export const GET_SAVED_FILTERS_FOR_STAFF = 'GET_SAVED_FILTERS_FOR_STAFF'
export const DELETE_SAVED_FILTER = 'DELETE_SAVED_FILTER'
export const SAVE_UPDATE_MY_FILTER = 'SAVE_UPDATE_MY_FILTER'
export const CLEAR_MY_FILTER = 'CLEAR_MY_FILTER'
export const DOWNLOAD_STUDENT_REPORT = 'DOWNLOAD_STUDENT_REPORT'
export const GET_MY_STUDENT_COLUMNS = 'GET_MY_STUDENT_COLUMNS'
export const REMOVE_STUDENTS_FROM_SELECTED_GROUP = 'REMOVE_STUDENTS_FROM_SELECTED_GROUP'
export const ADD_STUDENTS_TO_SELECTED_GROUP = 'ADD_STUDENTS_TO_SELECTED_GROUP'
export const CLEAR_SELECTED_GROUP = 'CLEAR_SELECTED_GROUP'
export const CHECK_IF_REPORT_AVAILABLE = 'CHECK_IF_REPORT_AVAILABLE'
export const DOWNLOAD_STUDENT_REPORT_CSV = 'DOWNLOAD_STUDENT_REPORT_CSV'
export const UPDATE_STUDENT_ACCESSIBILITY = 'UPDATE_STUDENT_ACCESSIBILITY'
export const UPDATE_CURRENT_ACCESSIBILITY_FLAG = 'UPDATE_CURRENT_ACCESSIBILITY_FLAG'
export const GET_CURRENT_ACCESSIBILITY_FLAG = 'GET_CURRENT_ACCESSIBILITY_FLAG'
export const CREATE_DEFAULT_MYGROUP = 'CREATE_DEFAULT_MYGROUP'
export const ADD_STUDENTS_TO_MYGROUP = 'ADD_STUDENTS_TO_MYGROUP'
export const REMOVE_STUDENTS_FROM_MYGROUP = 'REMOVE_STUDENTS_FROM_MYGROUP'
export const UPDATE_MY_FILTER = 'UPDATE_MY_FILTER'
export const UPDATE_DEFAULT_FILTER = 'UPDATE_DEFAULT_FILTER'

// Staff specific
export const GET_TUTOR_BOOLEAN = 'GET_TUTOR_BOOLEAN'

// Student graphing data
// export const GET_STUDENT_ENGAGEMENT = 'GET_STUDENT_ENGAGEMENT'
// export const GET_STUDENT_COURSE_AVERAGE = 'GET_STUDENT_COURSE_AVERAGE'
// export const GET_STUDENT_COURSE_TOP = 'GET_STUDENT_COURSE_TOP'
// export const GET_STUDENT_CUMULATIVE_ENGAGEMENT = 'GET_STUDENT_CUMULATIVE_ENGAGEMENT'
// export const GET_STUDENT_CUMULATIVE_COURSE_AVERAGE = 'GET_STUDENT_CUMULATIVE_COURSE_AVERAGE'
// export const GET_STUDENT_CUMULATIVE_COURSE_TOP = 'GET_STUDENT_CUMULATIVE_COURSE_TOP'
export const GET_STUDENT_CALENDAR_INFORMATION = 'GET_STUDENT_CALENDAR_INFORMATION'
// export const GET_STUDENT_EXEMPTIONS = 'GET_STUDENT_EXEMPTIONS'
export const GET_STUDENT_GRAPH_DATA = 'GET_STUDENT_GRAPH_DATA'
export const CHECK_IF_GRAPH_AVAILABLE = 'CHECK_IF_GRAPH_AVAILABLE'
export const DOWNLOAD_GRAPH_DATA = 'DOWNLOAD_GRAPH_DATA'

// Intervention specific
export const GET_INTERVENTION_STUDENTS_LIST = 'GET_INTERVENTION_STUDENTS_LIST'
export const GET_DROPDOWN_VALUES = 'GET_DROPDOWN_VALUES'
export const POST_INTERVENTION_COMMENT = 'POST_INTERVENTION_COMMENT'
export const DELETE_INTERVENTION_BY_ID = 'DELETE_INTERVENTION_BY_ID'
export const UNDO_DELETE_INTERVENTION_BY_ID = 'UNDO_DELETE_INTERVENTION_BY_ID'
export const GET_INTERVENTION_COUNT = 'GET_INTERVENTION_COUNT'
export const POST_INTERVENTION_FORM = 'POST_INTERVENTION_FORM'
export const POST_BULK_INTERVENTION_FORM = 'POST_BULK_INTERVENTION_FORM'
export const RESET_INTERVENTION_MODULES = 'RESET_INTERVENTION_MODULES'
export const REOPEN_INTERVENTION = 'REOPEN_INTERVENTION'

// Interactions specific
export const GET_INTERACTIONS_LIST = 'GET_INTERACTIONS_LIST'
export const GET_INTERACTIONS_LIST_START = 'GET_INTERACTIONS_LIST_START'
export const CHANGE_INTERACTIONS_SORTING = 'CHANGE_INTERACTIONS_SORTING'
export const CHANGE_INTERACTIONS_FILTER = 'CHANGE_INTERACTIONS_FILTER'
export const CLEAR_INTERACTIONS_FILTERS = 'CLEAR_INTERACTIONS_FILTERS'
export const UPDATE_INTERACTIONS_PAGE = 'UPDATE_INTERACTIONS_PAGE'
export const GET_INTERVENTION_INTERACTIONS = 'GET_INTERVENTION_INTERACTIONS'
export const GET_ALERT_INTERACTIONS = 'GET_ALERT_INTERACTIONS'

// Undo specific
export const SET_UNDO_STATE_ASYNC = 'SET_UNDO_STATE_ASYNC'

export const CLOSE_INTERVENTION = 'closeIntervention'

// Admin specific
export const SEND_ADMIN_ALERT_UPDATE = 'SEND_ADMIN_ALERT_UPDATE'
export const SAVE_ADMIN_ALERT_HIERARCHY = 'SAVE_ADMIN_ALERT_HIERARCHY'
export const GET_ADMIN_ALERTS = 'GET_ADMIN_ALERTS'
export const CREATE_ADMIN_ALERT_EMAIL_TEMPLATE = 'CREATE_ADMIN_ALERT_EMAIL_TEMPLATE'
export const SAVE_ADMIN_ALERT_EMAIL = 'SAVE_ADMIN_ALERT_EMAIL'
export const DELETE_ADMIN_ALERT_EMAIL = 'DELETE_ADMIN_ALERT_EMAIL'
export const GET_CUSTOM_FILTERS_FOR_ALERTS = 'GET_CUSTOM_FILTERS_FOR_ALERTS'
export const GET_ENROLMENT_STATUS_FILTER = 'GET_ENROLMENT_STATUS_FILTER'
export const ALERTS_CHANGE_FILTER = 'ALERTS_CHANGE_FILTER'
export const ALERTS_CHANGE_LIST_FILTER = 'ALERTS_CHANGE_LIST_FILTER'
export const GET_STUDY_MODES_ALERTS = 'GET_STUDY_MODES_ALERTS'
export const GET_COURSE_YEARS_ALERTS = 'GET_COURSE_YEARS_ALERTS'
export const GET_COURSE_LEVELS_ALERTS = 'GET_COURSE_LEVELS_ALERTS'
export const UPDATE_ALL_ALERT_FILTERS = 'UPDATE_ALL_ALERT_FILTERS'

// Alert specific
export const GET_ALERTS_LANDING = 'GET_ALERTS_LANDING'
export const GET_SINGLE_ALERT = 'GET_SINGLE_ALERT'
export const CREATE_INITIAL_ALERT = 'CREATE_INITIAL_ALERT'
export const UPDATE_ALERT_CRITERIA = 'UPDATE_ALERT_CRITERIA'
export const COPY_ALERT = 'COPY_ALERT'
export const DELETE_ALERT = 'DELETE_ALERT'
export const GET_STUDENT_AFFECTED_COUNT = 'GET_STUDENT_AFFECTED_COUNT'

export const CANCEL_AFFECTED_STUDENT_CALCULATION = 'CANCEL_AFFECTED_STUDENT_CALCULATION'
export const UPDATE_ALERT_ACTIVE_CRITERIA = 'UPDATE_ALERT_ACTIVE_CRITERIA'
export const EDIT_ALERT_DETAILS = 'EDIT_ALERT_DETAILS'
export const EDIT_ALERT = 'EDIT_ALERT'
export const CLEAR_ALERT_FILTERS_ACTION = 'CLEAR_ALERT_FILTERS_ACTION'
export const GET_SAVED_FILTERS_FOR_ALERT = 'GET_SAVED_FILTERS_FOR_ALERT'
export const ORGANISE_ALERT_FILTERS = 'ORGANISE_ALERT_FILTERS'
export const GET_COURSES_FOR_ALERTS = 'GET_COURSES_FOR_ALERTS'
export const GET_ALL_COURSES_FOR_ALERTS = 'GET_ALL_COURSES_FOR_ALERTS'
export const ORGANISE_ALERT_FILTERS_CHECK_LIST = 'ORGANISE_ALERT_FILTERS_CHECK_LIST'
export const ALERT_FILTER_DRAWER = 'ALERT_FILTER_DRAWER'
export const CHECK_STUDENT_COUNT_AVAILABLE = 'CHECK_STUDENT_COUNT_AVAILABLE'

// Alert frequency specific

// Alert DataSet specific
export const GET_DATA_SET_ITEMS = 'GET_DATA_SET_ITEMS'
export const POST_NEW_DATA_SET_ITEM = 'POST_NEW_DATA_SET_ITEM'
export const UPDATE_DATA_SET_ITEM = 'UPDATE_DATA_SET_ITEM'
export const DELETE_DATA_SET_ITEM = 'DELETE_DATA_SET_ITEM'

// Alert template specific
export const GET_TEMPLATE_PLACEHOLDERS = 'GET_TEMPLATE_PLACEHOLDERS'
export const POST_NEW_EMAIL_TEMPLATE_ITEM = 'POST_NEW_EMAIL_TEMPLATE_ITEM'
export const UPDATE_EMAIL_TEMPLATE_ITEM = 'UPDATE_EMAIL_TEMPLATE_ITEM'
export const DELETE_EMAIL_TEMPLATE_ITEM = 'DELETE_EMAIL_TEMPLATE_ITEM'
export const GET_DELIVERY_METHODS = 'GET_DELIVERY_METHODS'

// Hierarchy Tree specific
export const GET_CLASS_HIERARCHY = 'GET_CLASS_HIERARCHY'
export const GET_SEARCH_HIERARCHY_RESULTS = 'GET_SEARCH_HIERARCHY_RESULTS'

// Exemption specific
export const CREATE_EXEMPTION = 'CREATE_EXEMPTION'
export const UPDATE_EXEMPTION = 'UPDATE_EXEMPTION'
export const DELETE_EXEMPTION = 'DELETE_EXEMPTION'
export const CREATE_GROUP_EXEMPTION = 'CREATE_GROUP_EXEMPTION'
export const UPDATE_GROUP_EXEMPTION = 'UPDATE_GROUP_EXEMPTION'

// Dashboard specific
export const GET_STUDENTS_COUNT = 'GET_STUDENTS_COUNT'
export const GET_LATEST_ENGAGEMENT_COUNT = 'GET_LATEST_ENGAGEMENT_COUNT'
export const GET_DASHBOARD_ALERTS_COUNT = 'GET_DASHBOARD_ALERTS_COUNT'
export const GET_DASHBOARD_LAST_SUCCESSFUL_JOBS = 'GET_DASHBOARD_LAST_SUCCESSFUL_JOBS'
export const GET_ENGAGEMENT_LAST_SUCCESSFUL = 'GET_ENGAGEMENT_LAST_SUCCESSFUL'
export const DASHBOARD_ENGAGEMENT_FILTER_CHANGE = 'DASHBOARD_ENGAGEMENT_FILTER_CHANGE'
export const DASHBOARD_ALERTS_FILTER_CHANGE = 'DASHBOARD_ALERTS_FILTER_CHANGE'
export const DASHBOARD_INTERVENTION_FILTER_CHANGE = 'DASHBOARD_INTERVENTION_FILTER_CHANGE'
export const DASHBOARD_CHANGE_FILTER = 'DASHBOARD_CHANGE_FILTER'
export const GET_DASHBOARD_AVAILABLE_CHART = 'GET_DASHBOARD_AVAILABLE_CHART'
export const GET_CHART_FOR_STAFF = 'GET_CHART_FOR_STAFF'
export const GET_DASHBOARD_GRAPHS = 'GET_DASHBOARD_GRAPHS'
export const GET_DASHBOARD_GRAPHS_DATA = 'GET_DASHBOARD_GRAPHS_DATA'
export const UPDATE_DASHBOARD_GRAPH_FILTERS = 'UPDATE_DASHBOARD_GRAPH_FILTERS'
export const GET_CUSTOM_FILTERS_FOR_CHARTS = 'GET_CUSTOM_FILTERS_FOR_CHARTS'
export const GET_STUDY_MODES_CHARTS = 'GET_STUDY_MODES_CHARTS'
export const GET_COURSE_YEARS_CHARTS = 'GET_COURSE_YEARS_CHARTS'
export const GET_COURSE_LEVELS_CHARTS = 'GET_COURSE_LEVELS_CHARTS'
export const GET_ENROLMENT_STATUS_CHARTS = 'GET_ENROLMENT_STATUS_CHARTS'
export const GET_COURSES_FOR_CHARTS = 'GET_COURSES_FOR_CHARTS'
export const GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT = 'GET_SAVED_FILTERS_FOR_CHARTS_ENDPOINT'
export const GET_SAVED_FILTERS_FOR_CHARTS = 'GET_SAVED_FILTERS_FOR_CHARTS'
export const GET_SAVED_FILTERS_FOR_CHARTS_ON_SELECTION = 'GET_SAVED_FILTERS_FOR_CHARTS_ON_SELECTION'
export const CLEAR_CHART_FILTERS_ACTION = 'CLEAR_CHART_FILTERS_ACTION'
export const ORGANISE_SAVED_FILTERS_FOR_CHART = 'ORGANISE_SAVED_FILTERS_FOR_CHART'
export const ORGANISE_FILTER_DATES_FOR_CHART = 'ORGANISE_FILTER_DATES_FOR_CHART'
export const DELETE_DASHBOARD_CHART = 'DELETE_DASHBOARD_CHART'
export const GET_CHART_LIMIT_BOOLEAN = 'GET_CHART_LIMIT_BOOLEAN'
export const UPDATE_DASHBOARD_GRAPH_SEQUENCE = 'UPDATE_DASHBOARD_GRAPH_SEQUENCE'
export const GET_MYTUTEES_DEFAULT_ENABLED = 'GET_MYTUTEES_DEFAULT_ENABLED'

// Resource specific
export const GET_STUDENT_RESOURCES = 'GET_STUDENT_RESOURCES'
export const GET_STUDENT_RESOURCE_WEIGHTINGS = 'GET_STUDENT_RESOURCE_WEIGHTINGS'
export const GET_STUDENT_RESOURCE_HISTORY = 'GET_STUDENT_RESOURCE_HISTORY'
export const GET_STUDENT_RESOURCE_HISTORY_NEXT = 'GET_STUDENT_RESOURCE_HISTORY_NEXT'

// Attendance specific
export const GET_STUDENT_ATTENDANCE_LIST = 'GET_STUDENT_ATTENDANCE_LIST'
export const GET_STUDENT_ATTENDANCE_LIST_NEXT = 'GET_STUDENT_ATTENDANCE_LIST_NEXT'
export const GET_STUDENT_ATTENDANCE_AVERAGE = 'GET_STUDENT_ATTENDANCE_AVERAGE'
export const GET_STUDENT_ATTENDANCE_SUMMARY_LIST = 'GET_STUDENT_ATTENDANCE_SUMMARY_LIST'
export const GET_STUDENT_MODULE_LIST = 'GET_STUDENT_MODULE_LIST'
export const GET_STUDENT_MODULE_ATTENDANCE_AVERAGE = 'GET_STUDENT_MODULE_ATTENDANCE_AVERAGE'
export const GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST = 'GET_STUDENT_MODULE_ATTENDANCE_SUMMARY_LIST'
export const GET_STUDENT_MODULE_ATTENDANCE_LIST = 'GET_STUDENT_MODULE_ATTENDANCE_LIST'
export const FILTER_SUMMARY_BY_DATE_RANGE = 'FILTER_SUMMARY_BY_DATE_RANGE'
export const RESET_ATTENDANCE_TIME_PICKERS = 'RESET_ATTENDANCE_TIME_PICKERS'

export const CHANGE_ATTENDANCE_MODULES_FILTERS = 'CHANGE_ATTENDANCE_MODULES_FILTERS'
export const CLEAR_ATTENDANCE_MODULES_FILTERS = 'CLEAR_ATTENDANCE_MODULES_FILTERS'

// Assessments specific
export const GET_STUDENT_ASSESSMENTS_LIST = 'GET_STUDENT_ASSESSMENTS_LIST'
export const GET_STUDENT_CURRENT_ASSESSMENTS = 'GET_STUDENT_CURRENT_ASSESSMENTS'
export const GET_STUDENT_ASSESSMENTS_LIST_LOADING = 'GET_STUDENT_ASSESSMENTS_LIST_LOADING'
export const GET_STUDENT_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR = 'GET_STUDENT_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR'
export const GET_STUDENT_MODULE_LIST_FOR_ASSESSMENT = 'GET_STUDENT_MODULE_LIST_FOR_ASSESSMENT'

// Feeds specific
export const GET_FEEDS_STATUS = 'GET_FEEDS_STATUS'
export const RUN_FEED = 'RUN_FEED'
export const UPDATE_FEED_STATUS = 'UPDATE_FEED_STATUS'
export const GET_FEEDS_FOR_DATE = 'GET_FEEDS_FOR_DATE'
export const RUN_FEED_WITH_COMMENTS = 'RUN_FEED_WITH_COMMENTS'
export const GET_FEED_ERROR_DETAILS = 'GET_FEED_ERROR_DETAILS'
export const CHECK_IF_FEED_REPORT_AVAILABLE = 'CHECK_IF_FEED_REPORT_AVAILABLE'
export const DOWNLOAD_FEED_ERROR_REPORT_CSV = 'DOWNLOAD_FEED_ERROR_REPORT_CSV'
export const GET_FEED_SPECIFIC_DETAILS = 'GET_FEED_SPECIFIC_DETAILS'

// Feeds Breakdown specific
export const LOAD_FEED_SCHEDULE_ID = 'LOAD_FEED_SCHEDULE_ID'
export const GET_FEED_BREAKDOWN_INFO = 'GET_FEED_BREAKDOWN_INFO'
export const GET_AUDIT_BREAKDOWN_INFO = 'GET_AUDIT_BREAKDOWN_INFO'
export const STORE_FEED_BREAKDOWN_AUDIT_ID = 'STORE_FEED_BREAKDOWN_AUDIT_ID'
export const DOWNLOAD_FEED_ERROR = 'DOWNLOAD_FEED_ERROR'

// Insights specific
export const GET_INSIGHTS_REPORT = 'GET_INSIGHTS_REPORT'
export const GET_GENERIC_REPORTS = 'GET_GENERIC_REPORTS'
export const GET_GENERIC_INSIGHTS_REPORT = 'GET_GENERIC_INSIGHTS_REPORT'
export const CHECK_INSIGHT_REPORT_AVAILABLE = 'CHECK_INSIGHT_REPORT_AVAILABLE'
export const DOWNLOAD_INSIGHT_REPORT_CSV = 'DOWNLOAD_INSIGHT_REPORT_CSV'

// Announcement specific
export const FETCH_USER_ANNOUNCEMENTS = 'FETCH_USER_ANNOUNCEMENTS'
export const FETCH_ALL_ANNOUNCEMENTS = 'FETCH_ALL_ANNOUNCEMENTS'
export const TOGGLE_ADMIN_ANNOUNCEMENT = 'TOGGLE_ADMIN_ANNOUNCEMENT'
export const SAVE_EDIT_ANNOUNCEMENT = 'SAVE_EDIT_ANNOUNCEMENT'
export const SAVE_NEW_ANNOUNCEMENT = 'SAVE_NEW_ANNOUNCEMENT'
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT'

// Groups specific
export const GET_GROUPS_LIST = 'GET_GROUPS_LIST'
export const GET_GROUP_DETAIL = 'GET_GROUP_DETAIL'
export const CREATE_GROUP = 'CREATE_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'
export const TRANSFER_STUDENTS_TO_ANOTHER = 'TRANSFER_STUDENTS_TO_ANOTHER'

// Data Purge specific
export const GET_DATA_PURGE_ENROLMENT_STATUS = 'GET_DATA_PURGE_ENROLMENT_STATUS'
export const GET_DATA_PURGE_DURATION = 'GET_DATA_PURGE_DURATION'
export const GET_DATA_PURGE_STUDENTS = 'GET_DATA_PURGE_STUDENTS'
export const SEARCH_DATA_PURGE_STUDENTS = 'SEARCH_DATA_PURGE_STUDENTS'
export const DOWNLOAD_DATA_PURGE_REPORT = 'DOWNLOAD_DATA_PURGE_REPORT'
export const CHECK_DATA_PURGE_REPORT_AVAILABLE = 'CHECK_DATA_PURGE_REPORT_AVAILABLE'
export const DOWNLOAD_DATA_PURGE_REPORT_CSV = 'DOWNLOAD_DATA_PURGE_REPORT_CSV'
export const CHECK_FEED_IS_RUNNING = 'CHECK_FEED_IS_RUNNING'
export const DELETE_DATA_PURGE = 'DELETE_DATA_PURGE'
export const RESET_DATA_PURGE = 'RESET_DATA_PURGE'
export const CHECK_STUDENTS_ARE_MARKED_FOR_PURGE = 'CHECK_STUDENTS_ARE_MARKED_FOR_PURGE'
export const DOWNLOAD_DATA_TOBE_PURGED_REPORT = 'DOWNLOAD_DATA_TOBE_PURGED_REPORT'

// Config specific
export const CREATE_CONFIG_CATEGORY = 'CREATE_CONFIG_CATEGORY'
export const UPDATE_CONFIG_ITEM = 'UPDATE_CONFIG_ITEM'
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST'
export const GET_REFERRAL_LIST = 'GET_REFERRAL_LIST'
export const GET_EMAIL_TEMPLATE_LIST = 'GET_EMAIL_TEMPLATE_LIST'
export const GET_ENROLMENT_STATUS_LIST = 'GET_ENROLMENT_STATUS_LIST'
export const GET_EMAIL_TEMPLATE_PLACEHOLDERS = 'GET_EMAIL_TEMPLATE_PLACEHOLDERS'
export const SET_DEFAULT_EMAIL_TEMPLATE = 'SET_DEFAULT_EMAIL_TEMPLATE'
export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE'
export const UPDATE_CUSTOM_TEXT = 'UPDATE_CUSTOM_TEXT'
export const GET_CUSTOM_TEXT_MENU = 'GET_CUSTOM_TEXT_MENU'
export const UPDATE_REFERRAL = 'UPDATE_REFERRAL'
export const UPDATE_ENROLMENT_STATUS = 'UPDATE_ENROLMENT_STATUS'
export const DELETE_ENROLMENT_STATUS = 'DELETE_ENROLMENT_STATUS'
export const CREATE_REFERRAL = 'CREATE_REFERRAL'
export const CREATE_ENROLMENT_STATUS = 'CREATE_ENROLMENT_STATUS'

// Help specific
export const GET_HELP_TOPICS_FOR_LOCALE = 'GET_HELP_TOPICS_FOR_LOCALE'
export const DELETE_HELP_TOPIC_ARTICLE = 'DELETE_HELP_TOPIC_ARTICLE'
export const UPDATE_HELP_TOPIC_ARTICLE_ORDERS = 'UPDATE_HELP_TOPIC_ARTICLE_ORDERS'
export const UPDATE_HELP_TOPIC_ARTICLE = 'UPDATE_HELP_TOPIC_ARTICLE'
export const CREATE_HELP_TOPIC_ARTICLE = 'CREATE_HELP_TOPIC_ARTICLE'



// WEBPACK FOOTER //
// ./src/store/action-types.js